//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";


const getAllEcxSurveys = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/ecx-surveys")
}

const saveEcxSurvey = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/ecx-surveys",data)
}
const updateEcxSurvey = (clinicid,surveyid,data)=>{
    return axios.put(API_URL+"clinics/"+clinicid+"/ecx-surveys/"+surveyid,data)
}
const getEcxSurveyById = (clinicid,surveyid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/ecx-surveys/"+surveyid)
}
const deleteEcxSurvey = (clinicid,surveyid)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/ecx-surveys/"+surveyid)
}
const saveEcxSurveyTemplate = (data)=>{
    return axios.post(API_URL+"survey-templates",data)
}
const editEcxSurveyTemplate = (templateId,data)=>{
    return axios.put(API_URL+"survey-templates/"+templateId,data)
}
const deleteEcxSurveyTemplate = (templateId)=>{
    return axios.delete(API_URL+"survey-templates/"+templateId)
}
const deleteSurveyTemplateById = (templateId) => deleteEcxSurveyTemplate(templateId);

//Clinic Surveys from Admin
const getAllSurveys = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/surveys")
}

const getClinicSurveys = (clinicId, pageNo = 0, pageSize = 10, queryOptions = {}) => {
    const q = buildSurveyTemplateQuery(queryOptions);
    return axios.get(API_URL + `clinics/${clinicId}/surveys`, {
        params: { no: pageNo, size: pageSize, ...(q ? { q } : {}) },
    });
};

const getSurveyById = (clinicid,surveyid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/surveys/"+surveyid)
}

const updateClinicSurvey = (clinicId, surveyId, data) => {
    return axios.put(API_URL + `clinics/${clinicId}/surveys/${surveyId}`, data);
};

const deleteClinicSurvey = (clinicId, surveyId) => {
    return axios.delete(API_URL + `clinics/${clinicId}/surveys/${surveyId}`);
};

const installSurveyTemplate = (data) => {
    return axios.post(API_URL + 'survey-templates/install-to-clinic', data);
};

const buildSurveyTemplateQuery = ({ sortBy, sortOrder, searchField, searchTerm, statusFilter }) => {
    const parts = [];
    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }
    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }
    if (searchTerm?.trim()) {
        const field = searchField || 'title';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }
    if (statusFilter) {
        parts.push(`status==${statusFilter}`);
    }
    return parts.join(',');
};

const getSurveyTemplates = (pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildSurveyTemplateQuery(queryOptions);
    return axios.get(API_URL + 'survey-templates', {
        params: { no: pageNo, size: pageSize, q },
    });
};

const getAllSurveyTemplates = (pageNo = 0, pageSize = 20, sortBy = 'createdAt', sortOrder = 'DESC') => {
    return getSurveyTemplates(pageNo, pageSize, { sortBy, sortOrder });
};

const surveyService = {
    getAllEcxSurveys,
    saveEcxSurvey,
    updateEcxSurvey,
    getEcxSurveyById,
    deleteEcxSurvey,
    getAllSurveys,
    getClinicSurveys,
    getSurveyById,
    updateClinicSurvey,
    deleteClinicSurvey,
    installSurveyTemplate,
    getAllSurveyTemplates,
    getSurveyTemplates,
    saveEcxSurveyTemplate,
    editEcxSurveyTemplate,
    deleteEcxSurveyTemplate,
    deleteSurveyTemplateById
}

export default surveyService